import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=31bed03a&scoped=true&"
import script from "./Series.vue?vue&type=script&lang=js&"
export * from "./Series.vue?vue&type=script&lang=js&"
import style0 from "./Series.vue?vue&type=style&index=0&id=31bed03a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bed03a",
  null
  
)

export default component.exports